import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';

import { RootState } from '../..';
import { adminGetNotificationLogs } from './adminApi';
import { IUser } from '../../UserSlice';

export const NOTIFICATION_CHANNELS = {
  EMAIL: 'EMAIL',
  STORE: 'STORE',
  WHATSAPP: 'WHATSAPP',
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  GOOGLE_CHAT: 'GOOGLE_CHAT',
} as const;

export const NOTIFICATION_TYPES = {
  REPORT_ISSUE: 'REPORT_ISSUE',
  TRIAL_CLASS_CREATION_NOTIFICATION: 'TRIAL_CLASS_CREATION_NOTIFICATION',
  TRIAL_CLASS_TO_TUTOR: 'TRIAL_CLASS_TO_TUTOR',
  HOMEWORK_CREATE_TO_STUDENT: 'HOMEWORK_CREATE_TO_STUDENT',
  HOMEWORK_CREATE_TO_TUTOR: 'HOMEWORK_CREATE_TO_TUTOR',
  HOMEWORK_OVERDUE_TO_STUDENT: 'HOMEWORK_OVERDUE_TO_STUDENT',
  HOMEWORK_OVERDUE_TO_TUTOR: 'HOMEWORK_OVERDUE_TO_TUTOR',
  HOMEWORK_SUBMITTED_TO_TUTOR: 'HOMEWORK_SUBMITTED_TO_TUTOR',
  SEND_INVOICE_NOTIFICATIONS_TO_USER: 'SEND_INVOICE_NOTIFICATIONS_TO_USER',
  CHAT_NEW_MESSAGE_NOTIFICATION: 'CHAT_NEW_MESSAGE_NOTIFICATION',
  CHAT_UNREAD_MESSAGE_REMINDER: 'CHAT_UNREAD_MESSAGE_REMINDER',
  PREMIUM_TRIAL_EXPIRATION_REMINDER: 'PREMIUM_TRIAL_EXPIRATION_REMINDER',
  TUTOR_RATE_CONCERN_REQUEST_NOTIFICATION:
    'TUTOR_RATE_CONCERN_REQUEST_NOTIFICATION',
  TUTOR_RATE_CONCERN_RESOLVED_NOTIFICATION_TO_TUTOR:
    'TUTOR_RATE_CONCERN_RESOLVED_NOTIFICATION_TO_TUTOR',
  TUTOR_RATE_CONCERN_REJECTED_NOTIFICATION_TO_TUTOR:
    'TUTOR_RATE_CONCERN_REJECTED_NOTIFICATION_TO_TUTOR',
  TUTOR_FEEDBACK_LESSON_EXTENSION_NOTIFICATION_TO_ADMIN:
    'TUTOR_FEEDBACK_LESSON_EXTENSION_NOTIFICATION_TO_ADMIN',
  PENALTY_APPEAL_REQUEST_NOTIFICATION_TO_ADMIN:
    'PENALTY_APPEAL_REQUEST_NOTIFICATION_TO_ADMIN',
  MEETING_SCHEDULE_NOTIFICATION_TO_TUTOR:
    'MEETING_SCHEDULE_NOTIFICATION_TO_TUTOR',
  MEETING_SCHEDULE_NOTIFICATION_TO_STUDENT:
    'MEETING_SCHEDULE_NOTIFICATION_TO_STUDENT',
  MEETING_REMINDER_BEFORE_24_HOURS_TO_STUDENT:
    'MEETING_REMINDER_BEFORE_24_HOURS_TO_STUDENT',
  MEETING_REMINDER_BEFORE_1_HOUR_TO_TUTOR:
    'MEETING_REMINDER_BEFORE_1_HOUR_TO_TUTOR',
  MEETING_REMINDER_BEFORE_1_HOUR_TO_STUDENT:
    'MEETING_REMINDER_BEFORE_1_HOUR_TO_STUDENT',
  MEETING_REMINDER_BEFORE_30_MINS_TO_TUTOR:
    'MEETING_REMINDER_BEFORE_30_MINS_TO_TUTOR',
  MEETING_REMINDER_BEFORE_20_MINS_TO_ADMIN:
    'MEETING_REMINDER_BEFORE_20_MINS_TO_ADMIN',
  MEETING_REMINDER_BEFORE_10_MINS_TO_TUTOR:
    'MEETING_REMINDER_BEFORE_10_MINS_TO_TUTOR',
  MEETING_SCHEDULE_REMINDER_NOTIFICATION_TO_STUDENT:
    'MEETING_SCHEDULE_REMINDER_NOTIFICATION_TO_STUDENT',
  MEETING_LATE_JOIN_REMINDER_NOTIFICATION_TO_TUTOR:
    'MEETING_LATE_JOIN_REMINDER_NOTIFICATION_TO_TUTOR',
  PASSWORD_RESET_CODE_NOTIFICATION: 'PASSWORD_RESET_CODE_NOTIFICATION',
  ACCOUNT_CREATION_NOTIFICATION: 'ACCOUNT_CREATION_NOTIFICATION',
  ADMIN_PASSWORD_RESET_NOTIFICATION: 'ADMIN_PASSWORD_RESET_NOTIFICATION',
  TRIAL_MEETING_END_NOTIFICATIONS_TO_STUDENTS:
    'TRIAL_MEETING_END_NOTIFICATIONS_TO_STUDENTS',
  TRIAL_MEETING_END_REMINDER_NOTIFICATIONS_TO_STUDENTS:
    'TRIAL_MEETING_END_REMINDER_NOTIFICATIONS_TO_STUDENTS',
  MEETING_CANCELLATION_NOTIFICATION_TO_TUTOR:
    'MEETING_CANCELLATION_NOTIFICATION_TO_TUTOR',
  MEETING_CANCELLATION_NOTIFICATION_TO_STUDENT:
    'MEETING_CANCELLATION_NOTIFICATION_TO_STUDENT',
  MEETING_CANCELLATION_REQUEST_BY_TUTOR_NOTIFICATION_TO_STUDENT:
    'MEETING_CANCELLATION_REQUEST_BY_TUTOR_NOTIFICATION_TO_STUDENT',
  MEETING_LATE_CANCELLATION_WARNING_NOTIFICATION_TO_TUTOR:
    'MEETING_LATE_CANCELLATION_WARNING_NOTIFICATION_TO_TUTOR',
  MEETING_RESCHEDULED_NOTIFICATION_TO_TUTOR:
    'MEETING_RESCHEDULED_NOTIFICATION_TO_TUTOR',
  MEETING_RESCHEDULED_NOTIFICATION_TO_STUDENT:
    'MEETING_RESCHEDULED_NOTIFICATION_TO_STUDENT',
  MEETING_RESCHEDULE_REQUEST_BY_TUTOR_NOTIFICATION_TO_STUDENT:
    'MEETING_RESCHEDULE_REQUEST_BY_TUTOR_NOTIFICATION_TO_STUDENT',
  MEETING_RESCHEDULE_REQUEST_BY_TUTOR_NOTIFICATION_TO_TUTOR:
    'MEETING_RESCHEDULE_REQUEST_BY_TUTOR_NOTIFICATION_TO_TUTOR',
  MEETING_RESCHEDULE_REQUEST_BY_STUDENT_NOTIFICATION_TO_TUTOR:
    'MEETING_RESCHEDULE_REQUEST_BY_STUDENT_NOTIFICATION_TO_TUTOR',
  MEETING_LATE_RESCHEDULE_WARNING_NOTIFICATION_TO_TUTOR:
    'MEETING_LATE_RESCHEDULE_WARNING_NOTIFICATION_TO_TUTOR',
  MEETING_RESCHEDULE_REQUEST_BY_STUDENT_NOTIFICATION_TO_STUDENT:
    'MEETING_RESCHEDULE_REQUEST_BY_STUDENT_NOTIFICATION_TO_STUDENT',
  MEETING_RESCHEDULE_REQUEST_APPROVED_BY_ADMIN_NOTIFICATION_TO_TUTOR:
    'MEETING_RESCHEDULE_REQUEST_APPROVED_BY_ADMIN_NOTIFICATION_TO_TUTOR',
  MEETING_RESCHEDULE_REQUEST_REJECTED_BY_ADMIN_NOTIFICATION_TO_STUDENT:
    'MEETING_RESCHEDULE_REQUEST_REJECTED_BY_ADMIN_NOTIFICATION_TO_STUDENT',
  MEETING_CANCELLATION_REQUEST_REJECTED_BY_ADMIN_NOTIFICATION_TO_STUDENT:
    'MEETING_CANCELLATION_REQUEST_REJECTED_BY_ADMIN_NOTIFICATION_TO_STUDENT',
  MEETING_CANCELLATION_REQUEST_BY_TUTOR_NOTIFICATION_TO_TUTOR:
    'MEETING_CANCELLATION_REQUEST_BY_TUTOR_NOTIFICATION_TO_TUTOR',
  FEEDBACK_EXPIRATION_REMINDER_TUTOR: 'FEEDBACK_EXPIRATION_REMINDER_TUTOR',
  ANALYTICS_DATA_FOR_AI_BUDDY: 'ANALYTICS_DATA_FOR_AI_BUDDY',
  TUTORS_PAGE_NO_TUTORS_FOUND_NOTIFICATION:
    'TUTORS_PAGE_NO_TUTORS_FOUND_NOTIFICATION',
  TUTOR_CONTACT_BANK_DETAILS_UPDATE_TO_ADMIN:
    'TUTOR_CONTACT_BANK_DETAILS_UPDATE_TO_ADMIN',
  TRIAL_CONVERSION_NOTIFICATION_TO_ADMIN:
    'TRIAL_CONVERSION_NOTIFICATION_TO_ADMIN',
  USER_DETAILS_UPDATE_NOTIFICATIONS_TO_ADMIN:
    'USER_DETAILS_UPDATE_NOTIFICATIONS_TO_ADMIN',
  LOW_CREDIT_NOTIFICATION: 'LOW_CREDIT_NOTIFICATION',
  TRIAL_USER_LATE_JOIN_NOTIFICATION_TO_ADMIN:
    'TRIAL_USER_LATE_JOIN_NOTIFICATION_TO_ADMIN',
} as const;

export type TNotificationChannels = typeof NOTIFICATION_CHANNELS[keyof typeof NOTIFICATION_CHANNELS];
export type TNotificationTypes = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];
export interface INotificationLog {
  _id: string;
  tenant: string;
  type: TNotificationTypes;
  channel: TNotificationChannels;
  status: 'SUCCESS' | 'FAILED';
  user?: IUser;
  error?: string;
  metadata?: {
    [key: string]: any;
  };
  course?: string;
  section?: string;
  createdAt: string;
}

export interface IInitialNotificationLogState {
  status: 'idle' | 'loading' | 'rejected';
  // Admin
  adminNotificationLogListData?: {
    limit?: number;
    offset?: number;
    totalDocs?: number;
    list: Array<INotificationLog>;
  };
}

const initialState: IInitialNotificationLogState = {
  status: 'idle',
  adminNotificationLogListData: undefined,
};

export const NotificationLogSlice = createSlice({
  initialState,
  name: 'notificationLog',
  reducers: {
    resetAdminNotificationLogListData: (state) => {
      state.adminNotificationLogListData = undefined;
    },
  },
  extraReducers(builder) {
    builder.addCase(adminGetNotificationLogs.fulfilled, (state, action) => {
      const result = action.payload;

      const newAdminNotificationLogListData = {
        limit: result.limit,
        offset: result.offset,
        totalDocs: result.totalDocs || 0,
        list: result.docs || [],
      };

      state.adminNotificationLogListData = newAdminNotificationLogListData;
    });

    // Common Matchers
    builder.addMatcher(isPending(adminGetNotificationLogs), (state) => {
      state.status = 'loading';
    });
    builder.addMatcher(isFulfilled(adminGetNotificationLogs), (state) => {
      state.status = 'idle';
    });
    builder.addMatcher(isRejected(adminGetNotificationLogs), (state) => {
      state.status = 'rejected';
    });
  },
});

export const getNotificationLogState = (
  state: RootState
): RootState['notificationLog'] => state.notificationLog;

export const {
  resetAdminNotificationLogListData,
} = NotificationLogSlice.actions;

export * from './adminApi';
export default NotificationLogSlice.reducer;
